import React from 'react';
import PropTypes from 'prop-types';
import ImportFileDropDown from '../blocks/importFileDropdown';

const renderCheckboxes = (rowIsActive, index) => <div className="number-container"><span className="checkbox-custom-label">{index}</span><span className="checkbox" role="button" tabIndex={0} onClick={() => rowIsActive(index)} /></div>;

const renderRemoveRowTitle = removeDatRemoveRowTitle => <div className="remove-row-title-container">{removeDatRemoveRowTitle}</div>;

const RenderImportedFile = ({
  formattedFile,
  setCorrectColumnToCorrectTitle,
  removeCorrectColumnToCorrectTitle,
  importedFileTitleRow,
  placeholder,
  removeDatRemoveRowTitle,
  rowIsActive,
  checkedRows,
  importedFileActiveStep,
  formatApptexts,
}) => (<ul className="imported-file-ul" id="imported-file-ul">
  {importedFileActiveStep === 1 ? <div className="imported-file-ul-opacity" /> : null}
  {
    formattedFile.map((row, i) => {
      let className = 'imported-file-li';
      if (i === 0) {
        className += ' title-row';
      }
      if (i === 1) {
        className += ' li-below-title-dropzone-row';
      }
      if (checkedRows.includes(i)) {
        className += ' row-is-active';
      }
      return (
        <li className={className} key={row.id}>
          {i > 0 && importedFileActiveStep === 2 ? renderCheckboxes(rowIsActive, i) : null}
          {i === 0 && importedFileActiveStep === 2 ? renderRemoveRowTitle(removeDatRemoveRowTitle) : null}
          {row.map((item, index) => {
            const isTitleRow = item.titleRow;
            const value = item.value;
            if (isTitleRow) {
              if (importedFileActiveStep === 2) {
                const inputValue = (importedFileTitleRow[index] && importedFileTitleRow[index].text) || '';
                return <input key={item.id} readOnly placeholder={placeholder} className="imported-file-dropdown-remove" value={inputValue} id={`column-input-${index}`} />;
              }
              return (
                <div key={item.id} className="import-file-dropdown-container">
                  <ImportFileDropDown
                    newAppTexts={formatApptexts}
                    importedFileTitleRow={importedFileTitleRow}
                    index={index}
                    setCorrectColumnToCorrectTitle={setCorrectColumnToCorrectTitle}
                    removeCorrectColumnToCorrectTitle={removeCorrectColumnToCorrectTitle}
                    placeholder={placeholder}
                  />
                </div>
              );
            }
            return <input key={item.id} readOnly className="imported-file-input-field" value={value} id={`column-input-${index}`} />;
          })
          }
        </li>
      );
    })
}</ul>);

RenderImportedFile.propTypes = {
  formattedFile: PropTypes.array,
  setCorrectColumnToCorrectTitle: PropTypes.func,
  removeCorrectColumnToCorrectTitle: PropTypes.func,
  importedFileTitleRow: PropTypes.array,
  placeholder: PropTypes.string,
  removeDatRemoveRowTitle: PropTypes.string,
  rowIsActive: PropTypes.func,
  checkedRows: PropTypes.array,
  importedFileActiveStep: PropTypes.number,
  formatApptexts: PropTypes.array,
};

export default RenderImportedFile;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/renderImportedFile.js